import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

const apiClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Cookie is sent automatically by the browser; no manual token injection needed
apiClient.interceptors.request.use((config) => config);

export { API_BASE };
export default apiClient;
